<template>
  <div>
    <card>
      <template slot="header">
        <div class="d-flex justify-content-between">
          <h4 class="card-title">Dateien</h4>
          <button type="submit" class="btn btn-fill btn-primary"
            @click="openFileUploadDialog"
          >
            Hochladen
          </button>
        </div>
      </template>
      <div class="row" v-if="files.length">
        <div class="col-sm-4" v-for="file in files" :key="file.id" style="padding-bottom: 1em;">
          <a :href="`${baseUrl}/${file.file.id}`" :class="fileEditMode ? 'custom-link-danger' : 'custom-link'"
            @click="fileClick(file, $event)"
          >
            <div class="text-center">
              <i class="fas" :class="fileEditMode ? 'fa-trash' : 'fa-file'" style="font-size: 1.25em;"></i><br>
              {{ file.date | date }}<br>
              {{ file.file.original_name }}
            </div>
          </a>
        </div>
      </div>
      <p v-else>Keine Dateien vorhanden</p>
      <template slot="footer" v-if="files.length">
        <div class="text-center">
          <a href="#" @click.prevent="fileEditMode = !fileEditMode" class="custom-link">{{ fileEditMode ? 'Löschen beenden' : 'Dateien löschen' }}</a>
        </div>
      </template>
    </card>
    <file-upload-dialog
      :show="showFileUploadDialog"
      @submit="uploadFile"
      @close="closeFileUploadDialog"
      :val-errors="uploadErrors"
    />
  </div>
</template>

<script>
import FileUploadDialog from 'src/pages/Suppliers/file-upload-dialog'

export default {
  props: ['files', 'baseUrl'],
  components: { FileUploadDialog },
  data () {
    return {
      showFileUploadDialog: false,
      fileEditMode: false,
      uploadErrors: []
    }
  },
  methods: {
    async uploadFile (payload) {
      await this.initCsrf()

      this.$http.post(this.baseUrl, payload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(({ data }) => {
        this.$emit('fileUploaded', data)
        this.fileEditMode = false
        this.closeFileUploadDialog()
      }).catch(({ response }) => { this.uploadErrors = response.data.errors })
    },
    async fileClick (file, event) {
      if (this.fileEditMode) {
        event.preventDefault()
        if (confirm(`Datei ${file.file.original_name} wirklich löschen?`)) {
          await this.initCsrf()

          this.$http.delete(`${this.baseUrl}/${file.id}`).then(({ data }) => {
            this.$notify({
              message: `Datei ${data.file.original_name} erfolgreich gelöscht.`,
              type: 'success'
            })
            this.$emit('fileDeleted', data)
          })
        }
      }
    },
    openFileUploadDialog () {
      this.showFileUploadDialog = true
    },
    closeFileUploadDialog () {
      this.showFileUploadDialog = false
    }
  }
}
</script>

<style>
</style>
